module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/58f076fce6f7e6d43f0cd275e20a6641.png";